import React from "react";
import "./Header.css";

/**
 * App-shell top bar — slotted chrome for the dashboard (and PRD 2). Distinct
 * from the marketing AppBar header. Surface-aware.
 *
 * Props (all nodes, all optional):
 *   brand:    left — usually <BrandLockup size="sm" />
 *   search:   grows to fill, capped width
 *   actions:  right-aligned controls (help, +New Game, …)
 *   trailing: far right — usually <Avatar />
 */
const Header = ({ brand, search, actions, trailing, className = "", ...rest }) => (
  <header className={`gx-header ${className}`} {...rest}>
    {brand && <div className="gx-header-brand">{brand}</div>}
    {search && <div className="gx-header-search">{search}</div>}
    {/* Always push actions/trailing to the right. The search is capped at a
        max-width, so it and this spacer don't fight over the free space. */}
    <div className="gx-header-spacer" />
    {actions && <div className="gx-header-actions">{actions}</div>}
    {trailing && <div className="gx-header-trailing">{trailing}</div>}
  </header>
);

export default Header;
